import { create } from 'zustand';

/**
 * 全局应用状态接口
 */
interface AppState {
  /** 侧边栏是否收起 */
  sidebarCollapsed: boolean;
  /** 当前语言 */
  locale: string;
  /** 全局加载状态 */
  globalLoading: boolean;
  /** 主题模式 */
  themeMode: 'light' | 'dark';

  /** 切换侧边栏收起状态 */
  toggleSidebar: () => void;
  /** 设置侧边栏收起状态 */
  setSidebarCollapsed: (collapsed: boolean) => void;
  /** 设置语言 */
  setLocale: (locale: string) => void;
  /** 设置全局加载状态 */
  setGlobalLoading: (loading: boolean) => void;
  /** 切换主题 */
  toggleTheme: () => void;
}

/**
 * 全局应用状态 Store
 */
export const useAppStore = create<AppState>((set) => ({
  sidebarCollapsed: false,
  locale: 'zh-CN',
  globalLoading: false,
  themeMode: 'light',

  toggleSidebar: () => {
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
  },

  setSidebarCollapsed: (collapsed) => {
    set({ sidebarCollapsed: collapsed });
  },

  setLocale: (locale) => {
    set({ locale });
  },

  setGlobalLoading: (loading) => {
    set({ globalLoading: loading });
  },

  toggleTheme: () => {
    set((state) => ({
      themeMode: state.themeMode === 'light' ? 'dark' : 'light',
    }));
  },
}));
